import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { DemoContainer } from '@mui/x-date-pickers/internals/demo'
import TimetableFormCalendar from '../svg/TimetableFormCalendar'
import dayjs from 'dayjs'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import './calendar.scss'
import { ErrorMessage } from 'formik'
import { TextField } from '@mui/material'
import { useEffect, useState } from 'react'

const Calendar = ({
  value,
  onChange,
  className,
  label,
  width,
  placeholder,
  name,
  gap,
  showIcon = true,
  clearable = false,
  labelGap,
  required = false,
  errors,
  defaultToToday = false,
  disabled = false,
  maxBirthDate,
  shouldDisableDate,
}) => {
  function customOnChange(dateObject) {
    const newDate = dateObject?.format('DD/MM/YYYY')
    onChange(newDate)
  }

  const [cleared, setCleared] = useState(false)
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    if (cleared) {
      const timeout = setTimeout(() => {
        setCleared(false)
      }, 1500)

      return () => clearTimeout(timeout)
    }
    return () => {}
  }, [cleared])


  const today =  dayjs()
  const maxDate = today.subtract(15, 'year') // At least 15 years ago from today

  return (
    <div className='common-calendar-wrapper flex flex-column' style={{ width: width, gap: labelGap || '20px' }}>
      {label && (
        <label className='common-calendar-input-label' htmlFor=''>
          {label} <span>{required ? '*' : ''}</span>
        </label>
      )}
      <div className='common-calendar-gap flex flex-column' style={{ gap: gap }}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DemoContainer components={['DatePicker']}>
            <DatePicker
              className={`common-calendar ${errors != undefined && errors != null && errors[name] ? 'error-class' : className}`}
              value={value ? dayjs(value) : (defaultToToday ? dayjs() : null)}
              onChange={customOnChange}
              format='DD/MM/YYYY'
              renderInput={(params) => (
                <TextField 
                  {...params} 
                  placeholder={placeholder} 
                  onClick={() => setIsOpen(true)}
                  // onChange={handleDate} // Handle input change
                  disabled={disabled}
                />
              )}
              slots={{
                openPickerIcon: showIcon ? TimetableFormCalendar : () => '',
              }}
              open={isOpen}
              onClose={() => setIsOpen(false)}
              onOpen={() => setIsOpen(true)}
              slotProps={{
                textField: {
                  onClick: () => setIsOpen(true),
                },
                field: { clearable: clearable ? true : false, onClear: () => setCleared(true) },
              }}
              maxDate={maxBirthDate && maxDate} // Set maximum date
              disabled={disabled}
              shouldDisableDate={shouldDisableDate}
            />
          </DemoContainer>
        </LocalizationProvider>
        <ErrorMessage name={name} component='div' className='error-msg' />
      </div>
    </div>
  )
}

export default Calendar
